import Suporte from './suporte';

export default Suporte;